import * as React from 'react';
import { Header, Segment } from 'semantic-ui-react';

import IngresoNuevaMatricula from 'src/modulos/Matriculas/IngresoNuevaMatricula';
import { MatriculaState } from './tipos';

const FormularioCompleto: React.FunctionComponent<MatriculaState> = matriculaState => {
    return (
        <Segment>
            <Header as='h2' content='Formulario' />
            <IngresoNuevaMatricula stateInicial={matriculaState} soloLectura />
        </Segment>
    );
};

export default FormularioCompleto;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/comun/FormularioCompleto.tsx